<template>
  <div class="toolbar">
    <el-text title="全屏" @click="$emit('toggle-fullscreen')">
      <el-icon><FullScreen /></el-icon>
    </el-text>

    <el-text :title="setting ? '保持并退出设置' : '设置'" :class="setting ? 'setting' : ''" @click="$emit('toggle-setting')">
      <el-icon><Setting /></el-icon>
    </el-text>
  </div>
</template>

<script setup>
defineProps({ setting: Boolean })
defineEmits(['toggle-fullscreen', 'toggle-setting'])
</script>

<style lang="scss" scoped>
.toolbar {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  z-index: 999;
  border: 1px solid rgba(0, 148, 208, 0.8);
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  opacity: 0.2;

  &:hover {
    opacity: 1;
  }

  .el-text {
    color: var(--my-text-color);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border-right: 1px solid rgba(0, 148, 208, 0.8);

    &:nth-last-child(1) {
      border-right: none;
    }
    &.setting {
      background-color: var(--my-text-color);
      color: var(--my-bg-color);
    }
  }
}
</style>
